import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const fleetupConfig: TSPConfig = {
  key: 'fleetup',
  name: 'FleetUp',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the App ID and App Secret you were provided when your account was created.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Account ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
        { label: 'App Secret', name: 'database', type: 'text', required: true },
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
      ]}
    />
  ),
};

export default fleetupConfig;
